import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { WhiteLabelInfo } from "../models/model";

@Component({
  selector: "app-footer",
  imports: [],
  templateUrl: "./footer.component.html",
  styleUrl: "./footer.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  @Input() whiteLabelInfo: WhiteLabelInfo;
}
